import React from "react";
import { Button } from "primereact/button";

const OrderActions = ({ onDownloadPDF, onShowSummary }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 w-full">
      {/* Actions Section - Blue Theme - Compact */}
      <div className="bg-gradient-to-br from-blue-50/80 to-indigo-50/60 border border-blue-200/50 rounded-lg p-3 shadow-sm flex-1">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-6 h-6 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center shadow-sm">
            <svg
              className="w-3 h-3 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            </svg>
          </div>
          <div>
            <h3 className="font-display font-semibold text-sm text-blue-900 tracking-tight">
              Quick Actions
            </h3>
          </div>
        </div>

        {/* Action Buttons - Compact */}
        <div className="flex flex-row gap-2">
          <Button
            label="Export PDF"
            onClick={onDownloadPDF}
            className="bg-white hover:bg-blue-50 border border-blue-200 rounded-md shadow-sm hover:shadow-md transition-all duration-300 font-display font-medium px-2 py-1.5 text-blue-700 hover:text-blue-900 group flex-1 justify-center text-xs"
            icon={
              <svg
                className="w-3 h-3 mr-1 text-blue-500 group-hover:text-blue-600 transition-colors flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            }
          />
          <Button
            label="View Summary"
            onClick={onShowSummary}
            className="bg-white hover:bg-blue-50 border border-blue-200 rounded-md shadow-sm hover:shadow-md transition-all duration-300 font-display font-medium px-2 py-1.5 text-blue-700 hover:text-blue-900 group flex-1 justify-center text-xs"
            icon={
              <svg
                className="w-3 h-3 mr-1 text-blue-500 group-hover:text-blue-600 transition-colors flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default OrderActions;
